import { ReactNode } from 'react';

import { AccordionHeaderProps, Header as RadixHeader, Trigger } from '@radix-ui/react-accordion';

import { Icon } from '../../../Icon';

interface SectionHeaderProps extends AccordionHeaderProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function Header({ children, className, ...props }: SectionHeaderProps) {
  return (
    <RadixHeader className={className} {...props}>
      <Trigger
        role="tab"
        className="focus-ring group flex w-full flex-row items-center justify-between rounded-xl px-8 py-2 transition duration-300 radix-state-open:bg-neutral-100"
      >
        {children}
        <Icon icon="chevron-right" className="transition duration-300 group-radix-state-open:rotate-90" />
      </Trigger>
    </RadixHeader>
  );
}

export { Header };
